import GameStats from './GameStats.vue';

// @ts-ignore
GameStats.install = (Vue) => {
  Vue.component((GameStats as any).options.name, GameStats);
};

export default GameStats;
